module.exports = __webpack_public_path__ + "img/capslock.dce97fb1.svg";